// app/javascript/controllers/auto_reload_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    interval: { type: Number, default: 3600000 } // Default: 1 hour in milliseconds
  }

  connect() {
    this.startTimer()
  }

  disconnect() {
    this.stopTimer()
  }

  startTimer() {
    this.timer = setTimeout(() => {
      window.location.reload()
    }, this.intervalValue)
  }

  stopTimer() {
    if (this.timer) {
      clearTimeout(this.timer)
      this.timer = null
    }
  }
}
